var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(27.45098%,27.45098%,33.333333%)",
      fillOpacity: 1
    },
    d: "M 29.851562 26.304688 L 15.921875 2.601562 C 15.507812 1.894531 14.492188 1.894531 14.078125 2.601562 L 0.148438 26.304688 C -0.269531 27.023438 0.242188 27.929688 1.074219 27.929688 L 28.925781 27.929688 C 29.757812 27.929688 30.269531 27.023438 29.851562 26.304688 Z M 29.851562 26.304688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(35.686275%,36.470588%,43.137255%)",
      fillOpacity: 1
    },
    d: "M 18.167969 6.421875 C 13.742188 9.617188 10.859375 14.816406 10.859375 20.6875 C 10.859375 23.269531 11.421875 25.722656 12.421875 27.929688 L 28.925781 27.929688 C 29.757812 27.929688 30.269531 27.023438 29.851562 26.304688 Z M 18.167969 6.421875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,86.27451%,39.215686%)",
      fillOpacity: 1
    },
    d: "M 14.777344 5.492188 L 3.152344 25.28125 C 3 25.539062 3.1875 25.859375 3.484375 25.859375 L 26.515625 25.859375 C 26.8125 25.859375 27 25.539062 26.847656 25.28125 L 15.222656 5.492188 C 15.121094 5.324219 14.878906 5.324219 14.777344 5.492188 Z M 14.777344 5.492188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,94.117647%,50.980392%)",
      fillOpacity: 1
    },
    d: "M 10.859375 20.6875 C 10.859375 22.488281 11.132812 24.226562 11.636719 25.859375 L 26.515625 25.859375 C 26.8125 25.859375 27 25.539062 26.847656 25.28125 L 16.546875 7.746094 C 13.050781 10.957031 10.859375 15.566406 10.859375 20.6875 Z M 10.859375 20.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(27.45098%,27.45098%,33.333333%)",
      fillOpacity: 1
    },
    d: "M 16.035156 22.242188 C 16.035156 22.8125 15.574219 23.273438 15 23.273438 C 14.429688 23.273438 13.96875 22.8125 13.96875 22.242188 C 13.96875 21.667969 14.429688 21.207031 15 21.207031 C 15.574219 21.207031 16.035156 21.667969 16.035156 22.242188 Z M 16.035156 22.242188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(27.45098%,27.45098%,33.333333%)",
      fillOpacity: 1
    },
    d: "M 14.007812 12.492188 L 14.449219 19.140625 C 14.46875 19.429688 14.695312 19.65625 14.964844 19.65625 L 15.039062 19.65625 C 15.308594 19.65625 15.535156 19.429688 15.554688 19.140625 L 15.996094 12.492188 C 16.019531 12.167969 15.78125 11.898438 15.480469 11.898438 L 14.523438 11.898438 C 14.222656 11.898438 13.984375 12.167969 14.007812 12.492188 Z M 14.007812 12.492188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,78.431373%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 26.515625 26.378906 L 3.484375 26.378906 C 3.160156 26.378906 2.859375 26.203125 2.699219 25.925781 C 2.539062 25.644531 2.542969 25.296875 2.707031 25.019531 L 14.332031 5.230469 C 14.472656 4.992188 14.722656 4.847656 15 4.847656 C 15.277344 4.847656 15.527344 4.992188 15.667969 5.230469 L 27.292969 25.019531 C 27.457031 25.296875 27.460938 25.644531 27.300781 25.925781 C 27.140625 26.203125 26.839844 26.378906 26.515625 26.378906 Z M 3.714844 25.34375 L 26.285156 25.34375 L 15 6.132812 Z M 3.714844 25.34375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,86.27451%,39.215686%)",
      fillOpacity: 1
    },
    d: "M 26.285156 25.34375 L 11.488281 25.34375 C 11.585938 25.691406 11.691406 26.039062 11.808594 26.378906 L 26.515625 26.378906 C 26.839844 26.378906 27.140625 26.203125 27.300781 25.925781 C 27.460938 25.644531 27.457031 25.296875 27.292969 25.019531 L 16.941406 7.394531 C 16.675781 7.628906 16.414062 7.863281 16.160156 8.113281 Z M 26.285156 25.34375 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.21ee42e50a1d2cc568d67fb199cb038e.svg";
export { ForwardRef as ReactComponent };